import Grid from '@mui/material/Grid';
import Layout from '../../../componentsv2/Layout';
import Skeleton from '../../../componentsv2/Skeleton';
import Section from '../../../componentsv2/Section';

export default function AdminDashboardSkeleton() {
  return (
    <Layout>
      <Grid container rowSpacing={3}>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Skeleton variant="rectangular" animation="wave" height={40} width={100} />
          <Skeleton variant="rectangular" animation="wave" height={40} width={100} />
        </Grid>
        <Grid item xs={12}>
          <Section isFullHeight>
            <Grid container rowSpacing={2} columnSpacing={2}>
              <Grid item xs={12} md={4}>
                <Skeleton variant="rectangular" height={44} animation="wave" />
              </Grid>
              <Grid item xs={6} md={2}>
                <Skeleton variant="rectangular" height={44} animation="wave" />
              </Grid>
              <Grid item xs={6} md={2}>
                <Skeleton variant="rectangular" height={44} animation="wave" />
              </Grid>
              <Grid item xs={8} md={2}>
                <Skeleton variant="rectangular" height={44} animation="wave" />
              </Grid>
              <Grid item xs={4} md={2}>
                <Skeleton variant="rectangular" height={44} animation="wave" />
              </Grid>
              <Grid item xs={12}>
                <Skeleton variant="rectangular" height={500} animation="wave" />
              </Grid>
            </Grid>
          </Section>
        </Grid>
      </Grid>
    </Layout>
  );
}
